<template>
    <SKModal
        ref="modal"
        actionButtonsPosition="right"
        :hasAcceptButton="true"
        :acceptCallback="create"
        :accept-button-disabled="!this.file"
        :title="$t('admin.apps.status.promokit.title')"
    >
        <template v-slot:body>
            <div class="flex flex-row gap-4 items-center">
                <button class="sk-btn sk-btn-primary rounded-lg btn-border" @click="openFileInput">
                    {{ $t('admin.apps.status.promokit.upload')}}
                </button>
                <p class="mb-0" v-if="file">{{ file.name }}</p>
            </div>

            <vs-input
                ref="input-file"
                type="file"
                hidden
                :name="name"
                id="certificate"
                @change="onFileChange"
            />
        </template>
    </SKModal>
</template>
<script>

import LabelForm from '@/modules/Shared/Components/form/LabelForm'
import SKModal from "@/modules/Shared/Components/modal/SKModal";
import loader from "@/modules/Shared/Mixins/loader";
import AssetsService from "@/modules/Shared/Services/AssetsService";
import ApplicationService from "@/modules/Admin/Services/ApplicationService";

export default {
    name: 'ModalUploadPromokit',
    mixins: [loader],
    data() {
        return {
            file: null,
            filename: null,
        }
    },
    components: {
        LabelForm,
        SKModal,
    },
    methods: {
        open() {
            this.initialize()
            this.$refs['modal'].open()
        },
        initialize() {
            this.file = null
            this.filename = null
        },
        openFileInput() {
            this.$refs['input-file'].$refs.vsinput.click()
        },
        async handleUploadCertificate(file) {
            const binaryAsset = new Blob([file]);
            const name = `${Date.now()}__${file.name}`

            let presignedUrl = await AssetsService.getTempAssetResource(name)
            presignedUrl = presignedUrl.url

            await AssetsService.uploadFileInS3Resource(presignedUrl, binaryAsset)

            return name
        },
        onFileChange(event) {
            this.file = event.target.files[0]
        },
        async create() {
            await this.loadAndNotify(async () => {
                const filename = await this.handleUploadCertificate(this.file)
                await ApplicationService.editApplicationPromokit(this.$route.params.uuid, { promokit: filename })
                this.$emit('created')
            })
        }
    },
}
</script>
